// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_TEST_LOADING = 'ADD_TEST_LOADING';
export const ADD_TEST_SUCCESS = 'ADD_TEST_SUCCESS';
export const ADD_TEST_ERROR = 'ADD_TEST_ERROR';
export const UPDATE_TEST_LOADING = 'UPDATE_TEST_LOADING';
export const UPDATE_TEST_SUCCESS = 'UPDATE_TEST_SUCCESS';
export const UPDATE_TEST_ERROR = 'UPDATE_TEST_ERROR';
export const DELETE_TEST_LOADING = 'DELETE_TEST_LOADING';
export const DELETE_TEST_SUCCESS = 'DELETE_TEST_SUCCESS';
export const DELETE_TEST_ERROR = 'DELETE_TEST_ERROR';

function addTest(patientId: string, test: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/add${type}Test`,
      {
        ...test,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_TEST_LOADING,
    });
  });
}

function updateTest(patientId: string, test: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/update${type}Test`,
      {
        ...test,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_TEST_LOADING,
    });
  });
}

function deleteTest(patientId: string, testId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/delete${type}Test`,
      {
        testId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_TEST_LOADING,
    });
  });
}

export function addHIVTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'HIV');
}
export function updateHIVTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'HIV');
}
export function updateAdmissionHIV0Test(patientId: string, test: Object) {
  return updateTest(patientId, test, 'AdmissionHIV0');
}
export function updateAdmissionHIV6Test(patientId: string, test: Object) {
  return updateTest(patientId, test, 'AdmissionHIV6');
}
export function deleteHIVTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'HIV');
}
export function addTBTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'TB');
}
export function updateTBTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'TB');
}
export function deleteTBTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'TB');
}
export function addHemoglobinTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Hemoglobin');
}
export function updateHemoglobinTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Hemoglobin');
}
export function updateAdmissionHemoglobinTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'AdmissionHemoglobin');
}
export function deleteHemoglobinTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Hemoglobin');
}
export function addGlucoseTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Glucose');
}
export function updateGlucoseTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Glucose');
}
export function deleteGlucoseTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Glucose');
}
export function addSyphilisTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Syphilis');
}
export function updateSyphilisTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Syphilis');
}
export function deleteSyphilisTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Syphilis');
}
export function addCovidTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Covid');
}
export function updateCovidTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Covid');
}
export function deleteCovidTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Covid');
}
export function addUrinalysisTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Urinalysis');
}
export function updateUrinalysisTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Urinalysis');
}
export function deleteUrinalysisTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Urinalysis');
}
export function addMiscTest(patientId: string, test: Object) {
  return addTest(patientId, test, 'Misc');
}
export function updateMiscTest(patientId: string, test: Object) {
  return updateTest(patientId, test, 'Misc');
}
export function deleteMiscTest(patientId: string, testId: string) {
  return deleteTest(patientId, testId, 'Misc');
}


export function addTBScreening(patientId: string, test: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/addTBScreening`,
      {
        ...test,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_TEST_LOADING,
    });
  });
}

export function updateTBScreening(patientId: string, test: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/updateTBScreening`,
      {
        ...test,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_TEST_LOADING,
    });
  });
}

export function deleteTBScreening(patientId: string, testId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/deleteTBScreening`,
      {
        testId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_TEST_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_TEST_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_TEST_LOADING,
    });
  });
}

export const UPDATE_HIV_MOTHER_STATUS_LOADING = 'UPDATE_HIV_MOTHER_STATUS_LOADING';
export const UPDATE_HIV_MOTHER_STATUS_SUCCESS = 'UPDATE_HIV_MOTHER_STATUS_SUCCESS';
export const UPDATE_HIV_MOTHER_STATUS_ERROR = 'UPDATE_HIV_MOTHER_STATUS_ERROR';

export function updateHIVMotherStatus(patientId: string, status: bool) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/updateHIVMotherStatus`,
      {
        status,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_HIV_MOTHER_STATUS_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_HIV_MOTHER_STATUS_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_HIV_MOTHER_STATUS_LOADING,
    });
  });
}

export const UPDATE_TB_MOTHER_STATUS_LOADING = 'UPDATE_TB_MOTHER_STATUS_LOADING';
export const UPDATE_TB_MOTHER_STATUS_SUCCESS = 'UPDATE_TB_MOTHER_STATUS_SUCCESS';
export const UPDATE_TB_MOTHER_STATUS_ERROR = 'UPDATE_TB_MOTHER_STATUS_ERROR';

export function updateTBMotherStatus(patientId: string, status: bool) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/testing/updateTBMotherStatus`,
      {
        status,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_TB_MOTHER_STATUS_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_TB_MOTHER_STATUS_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_TB_MOTHER_STATUS_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/testingActions.js